import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ProductDetailUnit } from '@app/utils/enums/inventory-table-columns.enum';

export function unitValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value === ProductDetailUnit.EMPTY ? { unit: true } : null;
  };
}
